import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/pages/NotFound'
import PageForChina from '@/pages/PageForChina'
import FrameWithBack from '@/pages/help/FrameWithBack'
import Privacy from '@/pages/help/Privacy_202411.vue'
import DocViewer from '@/pages/help/DocViewer.vue'
import PrivacyCollection from '@/pages/help/PrivacyCollection_202609.vue'
import PrivacyThirdParty from '@/pages/help/PrivacyThirdParty_202609.vue'

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			name: 'NotFoundPage',
			component: NotFound
		},
		{
			path: '/cn', redirect: '/cn/faq'
		},
		{
			path: '/cn/:section',
			name: 'pageforchina',
			component: PageForChina,
			props: true
		},
        {
			path: '/cn/privacy/android',
			name: 'Privacy',
			component: Privacy,
		},
        {
			path: '/cn/privacy/kids',
			name: 'KidsPrivacy',
			component: DocViewer,
			props: () => ({ docKey: 'kidsPrivacy' })
		},
        {
			path: '/cn/privacy/kids/:version',
			name: 'KidsPrivacyVersion',
			component: DocViewer,
			props: route => ({ docKey: 'kidsPrivacy', version: route.params.version })
		},
        {
			path: '/cn/privacy/collection',
			name: 'PrivacyCollection',
			component: PrivacyCollection,
		},
        {
			path: '/cn/privacy/thirdparty',
			name: 'PrivacyThirdParty',
			component: PrivacyThirdParty,
		},
        {
			// 이전 버전 개인정보처리방침. 위의 고정 경로들보다 반드시 뒤에 선언되어야 한다.
			path: '/cn/privacy/:version',
			name: 'PrivacyVersion',
			component: DocViewer,
			props: route => ({ docKey: 'privacy', version: route.params.version })
		},
        {
			// 이전 버전 이용약관
			path: '/cn/tos/:version',
			name: 'TosVersion',
			component: DocViewer,
			props: route => ({ docKey: 'tos', version: route.params.version })
		},
		{
			path: '/frame/:page',
			name: 'frame',
			component: FrameWithBack,
			props: true
		}
	],
})
